import type { ApplicationEnvironment, User } from '@owl/shared';
import type { BucketSize } from '../../lib/buckets';

export type MobileRange = '1h' | '6h' | '24h' | '7d' | '30d' | 'mtd';

export type MobileViewMode = 'logs' | 'ai';

export type AppDashTab = 'logs' | 'activity' | 'ai' | 'info';

export type AlertsTab = 'events' | 'rules';

export type MobileRoute =
  | { name: 'overview' }
  | { name: 'apps' }
  | {
      name: 'appdash';
      applicationId: string;
      tab?: AppDashTab;
      /** Log to centre the feed on — set when arriving from a notification. */
      focusLogId?: string;
    }
  | { name: 'alerts'; tab?: AlertsTab }
  | { name: 'settings' };

export type MobileSheet =
  | { kind: 'log'; logId: string }
  | { kind: 'alertEvent'; eventId: string }
  | { kind: 'alertRule'; ruleId: string }
  | { kind: 'alertRuleEdit'; ruleId: string | null }
  | { kind: 'aiEvent'; eventIdx: number }
  | { kind: 'filter' }
  | {
      kind: 'bucketLogs';
      fromMs: number;
      size: BucketSize;
      applicationId?: string;
      applicationIds?: string[];
    }
  | { kind: 'search' };

export type MobileShellCtx = {
  user: User;
  onLogout: () => void;
  route: MobileRoute;
  navigate: (route: MobileRoute) => void;
  goBack: () => void;
  range: MobileRange;
  setRange: (r: MobileRange) => void;
  environment: ApplicationEnvironment;
  setEnvironment: (env: ApplicationEnvironment) => void;
  viewMode: MobileViewMode;
  setViewMode: (m: MobileViewMode) => void;
  refreshTick: number;
  triggerRefresh: () => void;
  sheet: MobileSheet | null;
  openSheet: (s: MobileSheet) => void;
  closeSheet: () => void;
  unreadAlerts: number;
  resetUnreadAlerts: () => void;
  liveConnected: boolean;
};

export const RANGE_OPTIONS: { label: string; value: MobileRange }[] = [
  { label: '1h', value: '1h' },
  { label: '6h', value: '6h' },
  { label: '24h', value: '24h' },
  { label: '7d', value: '7d' },
  { label: '30d', value: '30d' },
  { label: 'MTD', value: 'mtd' },
];

export function routeTitle(route: MobileRoute): string {
  switch (route.name) {
    case 'overview':
      return 'Overview';
    case 'apps':
      return 'Applications';
    case 'appdash':
      return 'Application';
    case 'alerts':
      return 'Alerts';
    case 'settings':
      return 'Ajustes';
  }
}
